import { render } from "./TiptapEditor.vue?vue&type=template&id=155e68c2"
import script from "./TiptapEditor.vue?vue&type=script&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&lang=js"

import "./TiptapEditor.vue?vue&type=style&index=0&id=155e68c2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__